'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');

const youtubeVideo = "_youtube-video_1fsa5_1";
const iframe = "_iframe_1fsa5_8";
const styles = {
	youtubeVideo: youtubeVideo,
	iframe: iframe
};

const useYouTubeIframeAPI = (youTubeId, events) => {
  React.useEffect(() => {
    const loadScriptTag = (scriptSrc) => {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      document.body.append(script);
    };
    const loadYouTubeIframeApi = () => {
      const youTubeIframeAPIReady = new Promise((resolve) => {
        const scriptSrc = "https://www.youtube.com/iframe_api";
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
        if (!existingScript) {
          loadScriptTag(scriptSrc);
        }
        const previousIframeApiReady = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          if (previousIframeApiReady) {
            previousIframeApiReady();
          }
          resolve(window.YT);
        };
      });
      return youTubeIframeAPIReady;
    };
    const loadIframe = () => {
      return loadYouTubeIframeApi().then((youTubeIframeAPI) => new youTubeIframeAPI.Player(`youtube-video-${youTubeId}`, {
        events
      })).catch(() => {
      });
    };
    if (events && Object.keys(events).length) {
      loadIframe();
    }
  }, [events, youTubeId]);
};
const YouTubeVideo = ({ title, youTubeId, allowFullscreen = true, aspectRatio = 16 / 9, autoplay = false, events = void 0, mute = false }) => {
  const [src, setSrc] = React.useState(
    // ?rel=0 makes only videos by Zapier show as related videos
    `https://www.youtube.com/embed/${youTubeId}?rel=0&autoplay=${Number(autoplay)}&mute=${Number(mute)}`
  );
  React.useEffect(() => {
    var _a;
    if (events && ((_a = Object.keys(events)) === null || _a === void 0 ? void 0 : _a.length)) {
      setSrc((prevState) => `${prevState}&enablejsapi=1&origin=${window.location.origin}`);
    }
  }, [events]);
  useYouTubeIframeAPI(youTubeId, events);
  const style = {
    paddingBottom: `${aspectRatio ** -1 * 100}%`
  };
  return jsxRuntime.jsx("div", { className: styles.youtubeVideo, style, "data-zds": true, children: jsxRuntime.jsx("iframe", { id: `youtube-video-${youTubeId}`, allow: allowFullscreen ? "fullscreen" : void 0, className: styles.iframe, frameBorder: "0", src, title }) });
};

exports.YouTubeVideo = YouTubeVideo;
exports.useYouTubeIframeAPI = useYouTubeIframeAPI;
//# sourceMappingURL=YouTubeVideo.cjs.js.map
